const contacts = [
  {
    type: 'Management',
    email: 'rooseveltthedr@gmail.com'
  },
  {
    type: 'North American / Canada Booking',
    name: 'Music Works International',
    email: 'booking@musicworksinternational.com'
  },
  {
    type: 'World Booking Agency',
    name: 'Contact',
    email: 'booking@musicworksinternational.com'
  }
];

export default contacts;



// WEBPACK FOOTER //
// ./src/data/contacts.jsx